import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import _ from "lodash";

import makeStyles from "@mui/styles/makeStyles";

import LanguageContext from "../../LanguageContext";
import messages from "../../services/messages";
import RecordedContentContainer from "../RecordedContentContainer";
import ZoomService from "../../services/ZoomService";
import UserService from "../../services/UserService";
import TopBar from "../TopBar";
import LiveContentContainer from "../LiveContentContainer";
import JWTTokenContext from "../../JWTTokenContext";
import UpcomingContentContainer from "../UpcomingContentContainer";
import CropService from "../../services/CropService";
import CropHeader from "./CropHeader";
import firebase from "../../firebase";
import JoinUsContainer from "../JoinUsContainer";
import moment from "moment";
import StateService from "../../services/StateService";
import VideosService from "../../services/VideosService";
import CropContentVideosContainer from "./CropContentVideosContainer";
import AuthorService from "../../services/AuthorService";
import StageService from "../../services/StageService";
import CropsListHorizontalScroll from "../CropsListHorizontalScroll";
import BottomBar from "../BottomBar";
import ErrorBoundary from "../ErrorBoundry";
import queryStringParser from "query-string";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";
const version = "2.11.0";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#F3F3F3",
    minHeight: window.innerHeight,
  },
  contentCard: {
    marginLeft: theme.spacing(2),
  },
  cropsContainer: {
    display: "flex",
    flexWrap: "nowrap",
    overflowX: "auto",
    overflowY: "hidden",
    WebkitOverflowScrolling: "touch",
  },
  cropsCardWrapper: {
    flex: "0 0 auto",
  },
  cropThumbnail: {
    width: theme.spacing(8),
    height: theme.spacing(8),
  },
  item: {
    textAlign: "center",
    padding: "4px",
    margin: "2px 0px",
  },
  greySection: {
    background: "#f1f1f1",
    padding: "4vh 0vh",
  },
  whiteSection: {
    background: "#fff",
    padding: "4vh 0vh 0vh 0vh",
  },
  whatYouGetTitleContainer: {
    marginBottom: theme.spacing(2),
  },
  whatYouGetText: {
    marginLeft: theme.spacing(4),
  },
  whatYouGetContainer: {
    marginTop: theme.spacing(4),
  },
  whatYouGetContent: {
    marginBottom: theme.spacing(3),
  },
  benefitContainer: {
    marginBottom: theme.spacing(3),
  },
}));

const meetingType = `meetings`;

function CropVideosPage(props) {
  const classes = useStyles();
  // const language = useContext(LanguageContext);
  const cropNameObjFromRoute = useParams("crop");
  const cropNameFromRoute = cropNameObjFromRoute.crop.toLowerCase();
  let [userState, setUserState] = useState("");
  const [open, setOpen] = React.useState(true);
  let [jwtToken, setJwtToken] = useState("");
  let [userLanguageCode, setUserLanguageCode] = useState("");
  let [recordedMeetings, setRecordedMeetings] = useState({});
  let [loadingRecordedMeetings, setLoadingRecordedMeetings] = useState(false);
  let [upcomingMeetings, setUpcomingMeetings] = useState({});
  let [allUpcomingMeetings, setAllUpcomingMeetings] = useState([]);
  let [allMeetingsByCrop, setAllMeetingsByCrop] = useState({});
  let [allMeetingsByCropFiltered, setAllMeetingsByCropFiltered] = useState({});
  let [loadingUpcomingMeetings, setLoadingUpcomingMeetings] = useState(false);
  let [liveMeetings, setLiveMeetings] = useState([]);
  let [loadingLiveMeetings, setLoadingLiveMeetings] = useState(false);
  let [recordedVideosCount, setRecordedVideosCount] = useState(null);
  let [upcomingMeetingsCount, setUpcomingMeetingsCount] = useState(null);
  let [loading, setLoading] = useState(false);
  let [free, setFree] = useState(false);
  let [name, setName] = useState(null);
  let [mobile, setMobile] = useState(null);
  let [farmerCrops, setFarmerCrops] = useState([]);
  let [cropList, setCropList] = useState([]);
  let [loadingCropList, setLoadingCropList] = useState(false);
  let userTypeVar = "premium";
  let [userType, setUserType] = useState(userTypeVar);
  let freeVar = false;
  let [contentVideos, setContentVideos] = useState([]);
  let [videosCount, setVideosCount] = useState(null);
  let [contentVideosCount, setContentVideosCount] = useState(null);
  let [recordingsCount, setRecordingsCount] = useState(null);
  let [sowingDate, setSowingDate] = useState(null);
  let [currentDaysAfterSowing, setCurrentDaysAfterSowing] = useState(null);
  let [currentWeeksAfterSowing, setCurrentWeeksAfterSowing] = useState(null);
  let [userSource, setUserSource] = useState("");
  let [visibleContentVideos, setVisibleContentVideos] = useState([]);
  let cropFromRoute = {};
  if (props.referenceData && props.referenceData.crops) {
    cropFromRoute = CropService.getCropByName(
      props.referenceData.crops,
      cropNameFromRoute
    );
  }

  const handleClick = () => {
    setOpen(!open);
  };
  const numberOfDefaultVisibleContentVideos = 10;
  const seeMoreContentVideos = () => {
    firebase.analytics().logEvent("content_videos_see_more_clicked", {
      state_name: userState,
      mobile: mobile,
      user_type: userTypeVar,
      user_source: userSource,
      currentVisibleCount: visibleContentVideos.length,
      crop_name: cropNameFromRoute,
    });
    setVisibleContentVideos(
      contentVideos.slice(
        0,
        visibleContentVideos.length + numberOfDefaultVisibleContentVideos
      )
    );
  };

  const getVideosCount = (crop, userState, userType) => {
    let videosCount = 0;
    let recordingsCount = 0;

    if (crop) {
      videosCount = CropService.getVideosCount(crop, userState, userType);
      setVideosCount(videosCount);
    }
  };

  const getContentVideosCount = (crop, userState) => {
    let videosCount = 0;
    let recordingsCount = 0;

    if (crop) {
      videosCount = CropService.getContentVideosCount(crop, userState);
      setContentVideosCount(videosCount);
    }
  };

  const fetchMeetings = async () => {
    console.log(localStorage.getItem("languageCode"));
    if (
      localStorage.getItem("mobile") &&
      localStorage.getItem("languageCode")
    ) {
      setLoadingCropList(true);
      let { crops, authors, states, stages } = props.referenceData;

      let userStateFromLocal = localStorage.state;
      let userLangCodeFromLocal = localStorage.languageCode;

      let userSourceFromLocal = localStorage.userSource;
      let userSourceVar = "";
      if (!userSourceFromLocal || userSourceFromLocal === "") {
        userSourceVar = "WEB";
      } else {
        userSourceVar = userSourceFromLocal;
      }
      setUserSource(userSourceVar);
      let userStateName = userStateFromLocal;
      let userLanguageCodeVar = userLangCodeFromLocal;

      let userResponse = await UserService.getUser();
      let userFromResponse = userResponse.data;
      console.log({ userFromResponse });
      if (userFromResponse.name) {
        setName(userFromResponse.name);
      }

      if (userFromResponse.premium === false) {
        setFree(true);
        freeVar = true;
        userTypeVar = "free";
        setUserType(userTypeVar);
        localStorage.setItem("premium", userFromResponse.premium);
      } else {
        if (userFromResponse.migrated === true) {
          userTypeVar = "free_premium";
          setUserType(userTypeVar);
        } else if (userFromResponse.subscription_type === "free_premium") {
          userTypeVar = "free_premium";
          setUserType(userTypeVar);
        }
        if (
          userFromResponse.subscription_type &&
          userFromResponse.subscription_type === "freemium_1_month"
        ) {
          userTypeVar = "freemium_1_month";
          setUserType(userTypeVar);
        }
      }
      let mobileVar = "";
      if (userFromResponse.mobile) {
        setMobile(userFromResponse.mobile);
        mobileVar = userFromResponse.mobile;
        firebase.analytics().setUserId(userFromResponse.mobile);
        firebase.analytics().logEvent("crop_details_page_viewed", {
          state_name: userStateName,
          mobile: userFromResponse.mobile,
          user_type: userTypeVar,
          user_source: userSourceVar,
          gold_version: version,
        });
      }
      if (
        !userStateFromLocal ||
        userStateFromLocal === "" ||
        !userLangCodeFromLocal ||
        userLangCodeFromLocal === ""
      ) {
        if (userFromResponse.state) {
          let userStateFromResponse =
            userFromResponse.state.name_en.toLowerCase();
          let stateFromResponse = userFromResponse.state;
          localStorage.setItem("state", userStateFromResponse);
          setUserState(stateFromResponse);
          userStateName = userStateFromResponse;
          if (userFromResponse.state.language) {
            let userLangCodeFromResponse = userFromResponse.state.language.code;
            localStorage.setItem("languageCode", userLangCodeFromResponse);
            userLanguageCodeVar = userStateFromResponse;
            setUserLanguageCode(userLangCodeFromResponse);
          } else {
            userLanguageCodeVar = "mr";
            setUserLanguageCode("mr");
          }
        } else {
          setUserState(StateService.getStateByName(states, "maharashtra"));
          userStateName = "maharashtra";
          userLanguageCodeVar = "mr";
          setUserLanguageCode("mr");
        }
      } else {
        setUserState(StateService.getStateByName(states, userStateFromLocal));
        setUserLanguageCode(userLangCodeFromLocal);
      }

      console.log({ userLanguageCode });
      console.log({ userLangCodeFromLocal });
      if (userFromResponse.crops && userFromResponse.crops.length > 0) {
        let userCrops = userFromResponse.crops;

        userCrops = userCrops.filter((userCrop) => {
          return CropService.getCropByName(crops, userCrop.name)
            ? CropService.getCropByName(crops, userCrop.name)
            : false;
        });

        userCrops = userCrops.map((userCrop) => {
          if (cropFromRoute.name_en === userCrop.name) {
            return {
              ...userCrop,
              ...CropService.getCropByName(crops, userCrop.name),
              current: true,
            };
          } else {
            return {
              ...userCrop,
              ...CropService.getCropByName(crops, userCrop.name),
              current: false,
            };
          }
        });

        userCrops = userCrops.filter((userCrop) => {
          let videosCount = 0;
          videosCount = CropService.getVideosCount(
            userCrop,
            userStateName,
            userTypeVar
          );

          if (userCrop.type === "gold_crop") {
            if (videosCount && videosCount > 0) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        });

        userCrops = userCrops.map((userCrop) => {
          let videosCount = 0;
          videosCount = CropService.getVideosCount(
            userCrop,
            userStateName,
            userTypeVar
          );
          if (videosCount && videosCount > 0) {
            return { ...userCrop, total_videos_count: videosCount };
          } else {
            return { ...userCrop };
          }
        });

        let currentUserCrop = userCrops.filter((userCrop) => {
          return userCrop.current === true;
        })?.[0];

        userCrops = userCrops.filter((userCrop) => {
          return userCrop.current === false;
        });

        setCropList(userCrops);
        setLoadingCropList(false);

        if (currentUserCrop) {
          if (currentUserCrop.sowing_date) {
            setSowingDate(currentUserCrop.sowing_date);
            let momentSowingDate = moment(currentUserCrop.sowing_date).format(
              "DD-MMM-YYYY"
            );
            let currentDate = moment();
            let currentDaysAfterSowing = currentDate.diff(
              momentSowingDate,
              "days"
            );
            let currentWeeksAfterSowing = Math.floor(
              currentDaysAfterSowing / 7
            );
            setCurrentDaysAfterSowing(currentDaysAfterSowing);
            setCurrentWeeksAfterSowing(currentWeeksAfterSowing);
          }
        }

        if (cropFromRoute && cropFromRoute.name_en) {
          let userStateFromLocal = localStorage.state;
          let userStateObject = StateService.getStateByName(
            states,
            userStateFromLocal
          );
          if (userStateObject && userStateObject.code) {
            VideosService.getVideosForCropByState(
              cropFromRoute.name_en,
              userStateObject.code
            ).then((videosResponse) => {
              if (
                videosResponse &&
                videosResponse.data &&
                videosResponse.data.responseData &&
                videosResponse.data.responseData.length > 0
              ) {
                let videosData = videosResponse.data.responseData;
                videosData = videosData.map((contentVideo) => {
                  if (contentVideo && contentVideo.youTubeId) {
                    let youtube_id = contentVideo.youTubeId;
                    let youtube_thumbnail = `https://i.ytimg.com/vi/${youtube_id}/mqdefault.jpg`;
                    if (contentVideo.segment && contentVideo.author) {
                      let cropObj = CropService.getCropByName(
                        crops,
                        contentVideo.segment
                      );
                      let authorObj = AuthorService.getAuthorByName(
                        authors,
                        contentVideo.author
                      );
                      let stateObj = StateService.getStateByCode(
                        states,
                        contentVideo.stateCode
                      );
                      let stageName = "";
                      let stageIcon = "";
                      let stageObj = {};
                      if (contentVideo.stage) {
                        stageObj = StageService.getStageByName(
                          stages,
                          contentVideo.stage
                        );
                        if (
                          stageObj &&
                          !_.isEmpty(stageObj) &&
                          stageObj[`name_${userLanguageCodeVar}`]
                        ) {
                          stageName = stageObj[`name_${userLanguageCodeVar}`];
                          if (stageObj.image_avatar) {
                            stageIcon = stageObj.image_avatar;
                          }
                        }
                      }
                      if (
                        cropObj &&
                        cropObj[`name_${userLanguageCodeVar}`] &&
                        authorObj &&
                        authorObj[`name_${userLanguageCodeVar}`]
                      ) {
                        return {
                          ...contentVideo,
                          youtube_id,
                          youtube_url: `https://youtu.be/${youtube_id}`,
                          crop: contentVideo.segment,
                          crop_segment: contentVideo.segment,
                          shares_count: contentVideo.shares,
                          views_count: contentVideo.views,
                          state: contentVideo.stateData?.name_en,
                          cropData: cropObj,
                          cropName: cropObj[`name_${userLanguageCodeVar}`],
                          authorData: authorObj,
                          authorName: authorObj[`name_${userLanguageCodeVar}`],
                          authorImage: authorObj.image_avatar,
                          stageData: stageObj,
                          stageName: stageName,
                          stageIcon: stageIcon,
                          stateData: stateObj,
                          youtube_thumbnail: youtube_thumbnail,
                        };
                      }
                    }
                  }
                });

                videosData = videosData.filter((video) => {
                  return video && video.youtube_id;
                });
                setContentVideos(videosData);
                setVisibleContentVideos(
                  videosData.slice(0, numberOfDefaultVisibleContentVideos)
                );
                setLoading(false);
              }
            });
          }
        }
      }

      getContentVideosCount(cropFromRoute, userStateName);
      getVideosCount(cropFromRoute, userStateName, userTypeVar);
    } else {
    }
  };
  const saveUserAndRedirect = (
    isNew,
    mobile,
    userState,
    userSource,
    languageCode
  ) => {
    console.log({ languageCode });
    UserService.saveUser(
      "",
      mobile,
      userState.name_en.toLowerCase(),
      true,
      false,
      isNew,
      userSource,
      languageCode
    );

    UserService.saveUser(
      "",
      mobile,
      true,
      false,
      isNew,
      userSource,
      languageCode
    );
    fetchMeetings().then(() => {});
    firebase.analytics().logEvent("signup_success", {
      mobile: mobile,
      stateName: userState.name_en.toLowerCase(),
      source: userSource,
    });
    if (!userSource) {
      // history.push("/dashboard");
    } else {
      if (userSource === "APP" || userSource === "EMBED") {
        // history.replace(`/dashboard?source=${userSource}`);
      } else {
        // history.push(`/dashboard?source=${userSource}`);
      }
    }
  };
  useEffect(() => {
    setLoading(true);
    if (
      props.referenceData &&
      !_.isEmpty(props.referenceData) &&
      props.loadingMasterData === "done"
    ) {
      let queryParamString = window.location.search;
      let parsedParams = queryStringParser.parse(queryParamString);
      // {mobile: "9960342202", source: "APPMH", utm_source: "as_app"}
      if (
        parsedParams.mobile &&
        parsedParams.source &&
        parsedParams.utm_source
      ) {
        let validMobileRegex = /^[0-9]*$/;
        let mobileFromParam = null;
        if (parsedParams.mobile && validMobileRegex.test(parsedParams.mobile)) {
          mobileFromParam = parsedParams.mobile;
        }
        let stateFromParam = null;
        if (parsedParams.source && parsedParams.source.length === 5) {
          let stateCode;
          if (parsedParams.source.includes("APP")) {
            stateCode = parsedParams.source.split("APP").pop();
          }
          if (parsedParams.source.includes("B2B")) {
            stateCode = parsedParams.source.split("B2B").pop();
          }
          let state = StateService.getStateByCode(
            props.referenceData.states,
            stateCode
          );
          if (state) {
            stateFromParam = state;
          }
        }
        let trafficSource = "";
        if (parsedParams.utm_source) {
          trafficSource = parsedParams.utm_source;
        }
        let userSourceFromParam = "";
        if (trafficSource === "as_app") {
          userSourceFromParam = "APP";
        } else if (trafficSource === "as_embedded_app") {
          userSourceFromParam = "EMBED";
        } else if (trafficSource === "as_embedded_app_croppage") {
          userSourceFromParam = "EMBED_CROP";
        } else {
          userSourceFromParam = "WEB";
        }

        setUserSource(userSourceFromParam);
        console.log({
          mobileFromParam,
          stateFromParam,
          trafficSource,
          userSourceFromParam,
        });

        UserService.signup(
          "",
          mobileFromParam,
          stateFromParam,
          userSourceFromParam
        )
          .then(async (response) => {
            if (response && response.data) {
              if (response.data.result === "success") {
                saveUserAndRedirect(
                  response.data.isNew,
                  mobileFromParam,
                  stateFromParam,
                  userSourceFromParam,
                  response.data.state.language.code
                );
              } else {
                if (response.data.data) {
                  saveUserAndRedirect(
                    response.data.data.isNew,
                    mobileFromParam,
                    stateFromParam,
                    userSourceFromParam,
                    response.data.data.state.language.code
                  );
                } else {
                  let eventData = {
                    state_name: stateFromParam.name_en,
                    mobileFromParam,
                  };

                  if (response.data.message) {
                    eventData.reason = response.data.message;
                  }
                  firebase.analytics().logEvent("joingold_failed", eventData);
                }
              }
            }
          })
          .catch((error) => {
            firebase.analytics().logEvent("joingold_failed", {
              state_name: stateFromParam.name_en,
              source: "APP_BANNER",
              mobileFromParam,
              reason: "SOMETHING_WENT_WRONG",
            });
          });
      } else {
        let loggedInFlag = UserService.checkUserLogin();
        if (loggedInFlag === true) {
          fetchMeetings().then(() => {});
        }
      }
    }
  }, [props.referenceData, props.loadingMasterData]);

  useEffect(() => {
    UserService.logUser();
  }, []);

  return (
    <BlockUi tag="div" keepInView sx={{ minHeight: "90vh" }} blocking={loading}>
      <div className={classes.root}>
        <LanguageContext.Provider value={userLanguageCode}>
          <ErrorBoundary
            page={"crop-page"}
            section={"crop-header"}
            userSource={userSource}
          >
            <CropHeader
              crop={cropFromRoute}
              recordingsCount={recordedVideosCount}
              contentVideosCount={contentVideosCount}
              videosCount={videosCount}
              upcomingMeetingsCount={upcomingMeetingsCount}
              upcomingMeetings={upcomingMeetings}
              userType={userType}
              userState={userState}
              userSource={userSource}
              loading={loading}
            />
          </ErrorBoundary>
          {contentVideos && contentVideos.length > 0 && (
            <ErrorBoundary
              page={"crop-page"}
              section={"content-videos"}
              userSource={userSource}
              mobile={mobile}
            >
              <CropContentVideosContainer
                visibleContentVideos={visibleContentVideos}
                contentVideos={contentVideos}
                loading={loading}
                crops={props.referenceData.crops}
                userState={userState}
                userType={userType}
                userSource={userSource}
                sowingDate={sowingDate}
                farmerCrops={farmerCrops}
                currentDaysAfterSowing={currentDaysAfterSowing}
                currentWeeksAfterSowing={currentWeeksAfterSowing}
                setVisible={seeMoreContentVideos}
                defaultVisibleCount={numberOfDefaultVisibleContentVideos}
                mobile={mobile}
              />
              <br />
              <br />
            </ErrorBoundary>
          )}
        </LanguageContext.Provider>
      </div>
    </BlockUi>
  );
}

export default React.memo(CropVideosPage);
